<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-layout row wrap pa-6 pb-0>
                    <v-flex lg6 md6 sm12>
                        <v-autocomplete label="Khách hàng" v-model="currentItem.customer_id" :items="customers" :item-text="getCustomerText" item-value="id" class="input-group--focused" :disabled="currentItem.id > 0"></v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pa-6 pb-0>
                    <v-flex lg6 md6 sm12>
                        <v-text-field label="Ghi chú" v-model="currentItem.note"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pa-6 pt-0>
                    <v-layout row wrap justify-end pl-4 v-if="!currentItem.id">
                        <v-flex lg6 md6 sm8>
                            <v-autocomplete label="Sản phẩm" v-model="selectedProductId" :items="products" :item-text="getProductText" item-value="id" class="input-group--focused"></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 md6 sm4>
                            <h-currency-input label="Số lượng" v-model="productQty" class="input-group--focused" :decimal="0"></h-currency-input>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pl-4 v-if="!currentItem.id">
                        <v-flex lg12>
                            <v-btn
                                class="mx-2"
                                dark
                                small
                                color="red"
                                @click="addDetail"
                                :disabled="currentItem.id > 0"
                                ><v-icon dark>add</v-icon></v-btn
                            >
                        </v-flex>
                    </v-layout>
                    
                    <v-flex lg12>
                        <v-data-table :headers="detail_header" :items="currentItem.return_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                <td>{{ item.product_code }}</td>
                                <td>{{ item.product_name }}</td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.qty" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.qty | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.qty" type="number" step="1" label="Số lượng" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.unit_price" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.unit_price | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.unit_price" type="number" step="1" label="Đơn giá" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    <v-edit-dialog :return-value.sync="item.discount" eager lazy @save="updateLineItem(item)">
                                        <div>{{ item.discount | currency }}</div>
                                        <template v-slot:input>
                                            <v-text-field v-model="item.discount" type="number" step="1" label="Giảm giá" single-line autofocus></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-right">
                                    {{ item.price | currency }}
                                </td>
                                <td class="text-right">
                                    {{ item.line_total | currency }}
                                </td>
                                <td class="text-center">
                                    <v-icon v-if="!currentItem.id" medium @click="deleteDetail(item.product_id)">delete</v-icon>
                                </td>
                                </tr>
                            </template>
                            <template v-slot:body.append>
                                <tr class="total-summary-td">
                                    <td colspan="6" class="text-end font-weight-bold">Tổng số lượng:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.number_of_product | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="6" class="text-end font-weight-bold">Tổng tiền hàng:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.total | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="6" class="text-end font-weight-bold">Tổng giảm giá:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.discount | currency}}</td>
                                    <td></td>
                                </tr>
                                <tr class="total-summary-td">
                                    <td colspan="6" class="text-end font-weight-bold">Khách cần trả:</td>
                                    <td class="text-end font-weight-bold">{{ currentItem.amount | currency}}</td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-container>
    </div>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import { sendSuccessNotice, sendErrorNotice, pad } from "@/commons/utils";
    import { print_export_return } from "@/commons/hpod";
    export default {
        data() {
            return {
                detail_header: [
                    {
                        text: "Mã sản phẩm",
                        value: "product_code",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"],
                    },
                    {
                        text: "Tên sản phẩm",
                        value: "product_name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"],
                    },
                    {
                        text: "Số lượng",
                        value: "qty",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Đơn giá",
                        value: "unit_price",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Giảm giá",
                        value: "discount",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Giá bán",
                        value: "price",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "Thành tiền",
                        value: "line_total",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"],
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        width: "80px",
                    },
                ],
                dialogItem: false,
                selectedProductId: 0,
                productQty: 0
            }
        },
        computed: {
            ...mapState({
                loading: state => state.returns.loading,
                customers: state => state.users.all.data,
                products: state => state.products.all.data,
                currentItem: state => state.returns.selected,
            }),
            modifyId() {
                return this.$route.params.Pid;
            },
            isMobile() {
                if (screen.width <= 760) {
                    return true
                } else {
                    return false
                }
            },    
            adminRole() {
                return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
            },
        },
        watch: {
            modifyId() {
                this.refreshData();
            }
        },
        methods: {
            refreshData() {
                if (this.modifyId > 0) {
                    this.$store.dispatch("returns/getDetail", this.modifyId);
                }
                else {
                    this.$store.commit("returns/setDetail", { data: {
                            id: 0,
                            return_products: []
                        }
                    })
                }
            },
            getCustomerText(item) {
                return `${item.phone} - ${item.first_name}`
            },
            getProductText(item) {
                return `${item.product_code} - ${item.name}`
            },
            saveData() {
                this.$store.dispatch("returns/setDetail", {
                    data: this.currentItem,
                    id: this.currentItem.id
                }).then((p) => {
                    if (p.status == 200 && p.data && p.data.id) {
                        this.$router.push({
                            name: "ReturnDetail",
                            params: {
                                Pid: p.data.id,
                                title: `Chi tiết trả hàng (#${p.data.id})`
                            }
                         });
                    }
                });
            },
            addDetail() {
                if(this.selectedProductId > 0) {
                    if(this.currentItem.return_products === undefined || !this.currentItem.return_products) {
                        this.currentItem.return_products = []
                    }
                    if(_.find(this.currentItem.return_products, {'product_id': this.selectedProductId})) {
                        sendErrorNotice('Sản phẩm đã có trong đơn xuất');
                        return;
                    }
                    let product = _.find(this.products, {'id': this.selectedProductId});
                    this.currentItem.return_products.push({
                        product_id: product.id,
                        product_code: product.product_code,
                        product_name: product.name,
                        unit_price: product.price,
                        discount: 0,
                        price: product.price,
                        qty: this.productQty,
                        line_total: product.price*this.productQty
                    });
                }
                this.selectedProductId = 0;
                this.productQty = 0;
            },
            updateLineItem(item) {
                item.price = item.unit_price - item.discount;
                item.line_total = item.price * item.qty;
            },
            deleteDetail(id) {
                this.currentItem.return_products = _.filter(this.currentItem.return_products, (p) => {return p.product_id != id;});
            },
            printData() {
                if(!this.currentItem.id) {
                    sendErrorNotice('Lưu lại hoá đơn trước khi in ấn.');
                    return;
                }
                const frame_printing = print_export_return(this.currentItem, this.currentItem.return_products);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            }
        },
        mounted() {
            this.refreshData();
            this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
            this.$store.dispatch("products/getList", {filter: [{column: 'pro_type', value: 1, condition: "equal"}]});
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
            this.$root.$on("REQUEST_OTHER_ACTION", this.printData);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
            this.$root.$off("REQUEST_OTHER_ACTION", this.printData);
        },
    };
    </script>